"use client";
import { useEffect, useState } from 'react';

import { useLanguage } from "@/app/utils/LanguageContext";
import Footer from "@/app/ui/footer";
import Header from "@/app/ui/header";
import HeaderNav from "@/app/ui/headernav";

import dayJS, { formattedDate, dateFormat, toDate, isValidDate } from "@/app/utils/DayJS";
import _ from 'lodash';
import moment from "moment";
import { getAssetPrefix, adobeData, updateMetaTag, MeetingState } from "@/app/utils/Common";
import NoInformation from "../Common/NoInformation";
import { getSearchParams, paddingNum } from "@/app/utils/Common";
import Remarks from "@/app/ui/Common/remarks"
import { getChanges, getBusinessDate } from "@/app/utils/request/requestList";
import dayjs from "dayjs";

import { pageSet } from "@/app/utils/pageSet";

// import { getMetaTitle} from "@/app/utils/Metadata";
// import { Metadata } from "next";
// type Params = {language: string; }
// export async function generateMetadata(
//   { params }: { params: Params }
// ): Promise<Metadata> {
//   return {
//     title: getMetaTitle(params.language, pageSet.changes),
//   }
// }
// export function generateStaticParams(): { language: string }[] {
//   return [{ language: "en-us" }, { language: "zh-hk" }];
// }

const Changes: React.FC = () => {

  const { state: lang } = useLanguage();
  const assetPrefix = getAssetPrefix();
  const [loading, setloading ] = useState(true);  
  const { t, langCode } = lang; 
  const { racedate } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search)); 

  // let hasData = 1; //1: hasData, 2: noinfo, 3: willbeavailable -> test UI
  const [hasData, setHasData] = useState(1);
  const [data, setData] = useState<any>(null);
  const [changesData, setChangesData] = useState<any>(null);
  const [defaultDate, setDefaultDate] = useState("");
  const [bizdate, setbizdate] = useState("");


  useEffect(() => {
    updateMetaTag(langCode, pageSet.changes);
    adobeData(langCode, "pageview", {
      pageId: "racing/local",
    });

    // if(racedate){
    //   console.log("isValidDate",isValidDate(racedate, "YYYY/MM/DD"),racedate, hasData)
    //   const pattern = /^\d{4}\/\d{1,2}\/\d{1,2}$/;
    //   if (!pattern.test(racedate)) {
    //     setHasData(2);
    //     setloading(false);
    //     console.log("isValidDate 1",isValidDate(racedate, "YYYY/MM/DD"), hasData) 
    //     //return;
    //   }else {
    //     getData() 
    //   }
    // } else {
    //   getData() 
    // }  

    getBusinessDate().then((res: any) => {

      if(!res)
      {
        setHasData(2);
        setloading(false);
        return;
      } 

      const resbizdate: string = res?.timeOffset?.ts?.substring(0, res?.timeOffset?.ts?.indexOf('+'));

      const regex = /^\d{4}\/\d{2}\/\d{2}$/;
      console.log(resbizdate, "resbizdate------------")
      if ((regex.test(racedate) && dayjs(racedate).isBefore(resbizdate))) {
        console.log(resbizdate, "resbizdate isBefore------------")
        setHasData(3);
        setloading(false);
      } else if(racedate && !regex.test(racedate)){
        setHasData(2);
        setloading(false);
      } else {
        setbizdate(resbizdate);
      }
    })
  }, [])
  useEffect(() => {
    if (!bizdate) return
    //get QIDS Data 
    const date = handleDate(racedate, dateFormat.qids.dateWithoutTimezone)
    getChanges("")//2023-10-13
      .then(async (res: any) => {
        if(!res)
        {
          setHasData(2);
          setloading(false);
          return;
        } 
        console.log("getChanges", res) 
        const resmeeting = res?.commonMeetings?.filter((x: any) => x.venueCode.toUpperCase() != "CH")?.filter((x: any) => MeetingState("DECLARED").includes(x.status))
        if (!resmeeting || resmeeting?.length == 0) {
          // if (racedate) setHasData(3);
          // else setHasData(2);
          setHasData(3);
          return;
        }
        else if(racedate && resmeeting?.filter((x: any) => x.date == date)?.length == 0){
          setHasData(3)
          return; 
        }
 
        const dateList = [] as string[]
        _.orderBy(resmeeting, ["date"])?.forEach((item: any) => {
          if (!dateList.includes(item?.date)) {
            dateList.push(item?.date)
          }
        })

        const mtgList = dateList?.map((val: string, i: number) => {
          const h = resmeeting?.filter((x: any) => x.date == val)
          const curMtg = h?.map((x: any) => {
            return {
              ...x,
              isLocal: ["ST", "HV"].includes(x.venueCode.toUpperCase())
            }
          })
          const sortData = sortedChallengeList(curMtg);

          const venueDes = sortData?.map((x: any) => x.isLocal ? lang.langCode == "en-us" ? transformVenueDes(x.venueCode) : x.venueDes?.["chinese"] : `${x.venueCode} ${x.country?.sort((a:any,b:any) => a?.seq - b?.seq)?.map((i:any) => lang.langCode == "en-us" ? i?.nameen : i?.namech).join("/") ?? ""}`)
          return {
            date: val,
            raceCourse: venueDes.join(" / "),
            hasLocal: curMtg.filter((x: any) => x.isLocal)?.length > 0,
            changes: sortData,
            firstVenueCode: sortData?.[0]?.venueCode
          }
        })
        setData(mtgList)
        if (racedate) {
          const d = mtgList?.find((x: any) => x.date == date)
          if (d && d?.hasLocal) {
            setChangesData(d?.changes)
            setDefaultDate(date)
          } else if (d && !d?.hasLocal) {
            window.location.href = `/${lang.langCode}/overseas/changes?RaceDate=${moment(date).format('YYYYMMDD')}&Racecourse=${d.firstVenueCode}`
          }
        } else {
          const d = mtgList?.filter((x: any) => x.hasLocal)
          if (mtgList && mtgList?.length > 0 && d?.length > 0) {
            setChangesData(d[0]?.changes)
            setDefaultDate(d[0]?.date)
          } else if (mtgList?.length > 0 && d?.length == 0) {
            window.location.href = `/${lang.langCode}/overseas/changes?RaceDate=${moment(mtgList[0]?.date).format('YYYYMMDD')}&Racecourse=${mtgList?.[0]?.firstVenueCode}`
          }
        }
        console.log("getChanges dataList", mtgList)

      })
      .catch((e: any) => {
        console.log(e);
      }).finally(() => {
        setloading(false)
      });
  }, [bizdate])

  const transformVenueDes = (venue: string) => {
    let venueDes = "";
    switch(venue){
      case "ST":
        venueDes = "Sha Tin";
        break;
      case "HV":
        venueDes = "Happy Valley";
        break;
      default:
        ""
    }
    return venueDes
  }
  const sortedChallengeList = (challengeList: any) => {
    return challengeList.sort((a: any, b: any) => {
      if (a.isLocal !== b.isLocal) {
        return (b.isLocal ? 1 : 0) - (a.isLocal ? 1 : 0);
      }

      if (a.venueCode !== b.venueCode) {
        return a.venueCode - b.venueCode;
      }
    });
  }

  const compareDate = (a: any) => {
    return moment(a.time).format('YYYY-MM-DD');
  }

  const compareTime = (a: any) => {
    return moment(a.time).format('HH:mm:ss');
  }

  const compareSaddleClothNo = (a: any) => {
    return (a?.saddleClothNo ?? 0) <= 0
  }

  const compareSaddleClothNo2 = (a: any) => {
    return (a?.saddleClothNo ?? 0) <= 0 ? Number(a.runnerNo ?? 0) : a?.saddleClothNo
  }

  const compareType: any = (a: any) => {
    const typeMap = { "169": 1, "96": 2, "400": 3, "92": 4, "99": 5, "98": 6 };
    return typeMap[a.type as keyof typeof typeMap];
  }
  const filterChangeItems = (item: any) => {
    switch (item.type) {
      case "92":
      case "96":
      case "400":
      case "98":
      case "99":
        return true;
      case "169":
        if ("N" == item.scrResvIndicator) {
          return true;
        }
        break;
    }
    return false;
  }

  const handleDate = (date: string, format: string) => {
    return formattedDate(toDate(date, format), format)
  }

  const translateChangesItem = (item: any) => {
    let msg = "";
    let langType = (lang.langType === "english" ? 'en' : 'ch');
    console.log('item.type', item.type, t, item, langType);
    switch (item.type) {
      case "92":
        msg = t('changes_92')
          .replace('{runnerNo}', item.runnerNo)
          .replace('{horseName}', item["horseName_" + langType] + "");
        break;
      case "96":
        msg = t('changes_96')
          .replace('{runnerNo}', item.runnerNo)
          .replace('{scratchHorseName}', item["scratchHorseName_" + langType])
          .replace('{horseName2}', item["horseName_" + langType]);
        break;
      case "98":
        msg = t('changes_98')
          .replace('{runnerNo}', item.runnerNo)
          .replace('{horseName}', item["horseName_" + langType])
          .replace('{handicapWeight}', item.handicapWeight);
        break;
      case "99":
        msg = t('changes_99')
          .replace('{runnerNo}', item.runnerNo)
          .replace('{horseName}', item["horseName_" + langType])
          .replace('{jockeyName}', item["jockeyName_" + langType]||"");
        break;
      case "169":
        msg = t('changes_169')
          .replace('{runnerNo}', item.runnerNo)
          .replace('{horseName}', item["horseName_" + langType]);
        break;
      case "400":
        msg = t('changes_400')
          .replace('{runnerNo}', item.runnerNo)
          .replace('{reserve}', "R" == item.scrResvIndicator ? t('changes_reserve') : "")
          .replace('{horseName}', item["horseName_" + langType]);
        break;
    }
    return msg + formattedDate(toDate(item.time || '', [dateFormat.qids.datetimeWithMs, dateFormat.qids.datetime]), "(DD/MM HH:mm)");
  }

  const handleRaceHeader = (date: string, racecourse: string, hasLocal: boolean, firstVenueCode: string) => {

    const curDate = lang.langCode == "en-us" ?
      `${paddingNum(new Date(date).getDate())} ${new Date(date).toLocaleString(lang.langCode, { month: "short" })}`
      : `${new Date(date).toLocaleString(lang.langCode, { month: "short" })}${new Date(date).getDate()}日 `;

    console.log("handleRaceHeader", moment(date).format('YYYY/MM/DD '))
    return defaultDate == date ?
      (<a key={`raceHeader_${curDate}`} className="blueBtn1"> {curDate} - {t(racecourse)}</a>)
      :
      (<a key={`raceHeader_${curDate}`} className="greyBtn" href={`${hasLocal ? "?racedate=" + moment(date).format('YYYY/MM/DD') : "/" + lang.langCode + "/overseas/changes?RaceDate=" + moment(date).format('YYYYMMDD')}&Racecourse=${firstVenueCode}`}>
        {curDate} - {t(racecourse)}
      </a>)
  }

  const handleChanges = (item: any, race: any) => {

    const changes = item?.changeHistories.filter((x: any) => filterChangeItems(x)).filter((x: any) => x.raceNo == race.no)

    if (changes?.length === 0) {
      return (<p>&nbsp;--</p>)
    }

    let newChanges = [] as any[];
    _.forEach(_.orderBy(changes, ["time"], ["desc"]), function (item) {
      item.orderBy = paddingNum(item.runnerNo); 
      if(!newChanges?.find((x: any) => x.type == item.type && (x.saddleClothNov ?? 0) == (item.saddleClothNo ?? 0) && x.runnerNo == item.runnerNo) )
        newChanges.push(item)
      else if(item.type == "400" && !(newChanges?.find((x: any) => x.type == item.type)))
        newChanges.push(item)
    })

    console.log("changes", changes, newChanges)
    //const changesOrderByType = _.orderBy(changes, [compareType], ["asc"]);
    //const changesOrderByDate = _.orderBy(changesOrderByType, [compareDate], ["desc"]);
    //const changesOrder = _.orderBy(changesOrderByDate, ["orderBy"], ["asc"]);
    //console.log("changes changesOrderByType", changesOrderByType)
    //console.log("changes changesOrderByDate", changesOrderByDate)
    //console.log("changes changesOrder", changesOrder)

    const changesOrder = _.orderBy(newChanges, 
      [compareDate, compareSaddleClothNo, compareSaddleClothNo2, compareType, compareTime, "orderBy"], 
      ["desc", "asc", "asc", "asc", "desc", "asc"]);
    return (
      <div>
        {
          changesOrder?.map((change: any, idx: any) => {
            const msg = translateChangesItem(change)
            return (
              <p key={idx} dangerouslySetInnerHTML={{ __html: msg }}></p>
            )
          })
        }
      </div>
    )
  }

  if (loading) return null ;
  return (
    <>
      <div id='mainContainer'>
        <Header />
        <HeaderNav />
        { 
            hasData == 1 ?
              (
                <div className="commContent changes f_fs13">
                  <div style={{ width: "760px", paddingLeft: "10px", boxSizing: "content-box"}}>
                    <div className="commTitlePic">
                      <img src={`${assetPrefix}/images/title_ref_changes_${lang?.langCode == "en-us" ? "en" : "cn"}.gif`} />
                    </div>
                    <div className="date_title">
                      <div className="date_title f_tar">
                        {
                          data?.map((h: any) => handleRaceHeader(h.date, h.raceCourse, h.hasLocal, h.firstVenueCode))
                        }
                      </div>
                    </div>

                    {
                      changesData?.map((item: any, i: number) => (
                        <div key={`changes_${item.date}_${i}`}>
                          {item.isLocal ?
                            <div className="margin_top10 f_fs13 font_wb">{`${handleDate(item.date, dateFormat.display.date)}  ${lang.langCode == "en-us" ? transformVenueDes(item.venueCode) : item.venueDes?.["chinese"]}`}</div>
                            :
                            <div className="margin_top10 f_fs13 font_wb">{handleDate(item.date, dateFormat.display.date)}<span style={{ color: "#900" }}> {t("changes_overseas_races")} ({`${item.venueCode} ${item.country?.sort((a:any,b:any) => a?.seq - b?.seq)?.map((i:any) => lang.langCode == "en-us" ? i?.nameen : i?.namech).join("/")}`})</span></div>
                          }

                          <div className="margin_top10">
                            <table className="change_detail">
                              <thead>
                                <tr>
                                  <th className="f_fs13" style={{ width: "10%" }}>{t("changes_race")}</th>
                                  <th className="f_fs13 f_tal">{t("changes_description")}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  item?.races?.map((race: any, idx: number) => (
                                    <tr key={`race_${race.no}`}>
                                      <td className="f_tac"> {t("changes_race_no").replace("{0}", race.no)}</td>
                                      <td style={{ paddingLeft: "10px" }}>
                                        {handleChanges(item, race)}
                                      </td>
                                    </tr>
                                  ))
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                  <Remarks path="Changes" customClass="" />
                </div>
              )
              : (hasData == 2 ? (<NoInformation type="noinfo" />) :
                (
                  <NoInformation type="willbeavailable" PageName={t("pagename_Changes")} DirectPageName={t("pagename_RaceCard")} pageRemark="Changes" />
                ))
        }
      </div>
      <Footer />
    </>
  );
};
export default Changes;